import { Component, Children } from "react";
import PropTypes from "prop-types";

export default class MixpanelProvider extends Component {
  constructor(props, context) {
    super(props, context);
    this._mixpanel = props.mixpanel;
  }

  getChildContext() {
    return { mixpanel: this._mixpanel };
  }

  render() {
    const { children } = this.props;
    return Children.only(children);
  }
}
MixpanelProvider.propTypes = {
  mixpanel: PropTypes.shape({
    init: PropTypes.func.isRequired,
    track: PropTypes.func.isRequired
  }).isRequired,
  children: PropTypes.element.isRequired
};
MixpanelProvider.childContextTypes = {
  mixpanel: PropTypes.shape({
    init: PropTypes.func.isRequired,
    track: PropTypes.func.isRequired
  }).isRequired
};



// WEBPACK FOOTER //
// ./src/core/utils/MixpanelProvider.js